const ITEMS = [
  "FEDE & FITNESS ITALIA",
  "LIFE COACHING CRISTIANO",
  "LIFE COACH CRISTIANI",
  "METODO TEMPIO VIVO",
  "ELIO & CHIARA",
];

const Sequence = () => (
  <span className="inline-flex items-center">
    {ITEMS.map((t) => (
      <span key={t} className="inline-flex items-center">
        <span className="px-5 text-[0.62rem] uppercase tracking-[0.3em] text-[#F7F4EE]/90">{t}</span>
        <span className="text-[#C9A75D] text-[0.6rem]">✦</span>
      </span>
    ))}
  </span>
);

export const Marquee = () => (
  <div data-testid="top-marquee" className="marquee bg-[#0B0B0B] border-b border-[#262626] py-2.5">
    <div className="marquee-track">
      <Sequence />
      <Sequence />
      <Sequence />
      <Sequence />
    </div>
  </div>
);
